import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SidebarService {
  private collapsedSubject = new BehaviorSubject<boolean>(false);
  public collapsed$ = this.collapsedSubject.asObservable();

  constructor() {
    // Initialize with expanded state
    this.updateBodyClass(false);
  }

  get isCollapsed(): boolean {
    return this.collapsedSubject.value;
  }

  toggleCollapsed(): void {
    const newState = !this.collapsedSubject.value;
    this.collapsedSubject.next(newState);
    this.updateBodyClass(newState);
  }

  setCollapsed(collapsed: boolean): void {
    this.collapsedSubject.next(collapsed);
    this.updateBodyClass(collapsed);
  }

  private updateBodyClass(collapsed: boolean): void {
    if (collapsed) {
      document.body.classList.add('sidebar-collapsed');
      document.body.classList.remove('sidebar-expanded');
    } else {
      document.body.classList.add('sidebar-expanded');
      document.body.classList.remove('sidebar-collapsed');
    }
  }
}